import { Link } from "react-router-dom";
import { FaShieldAlt, FaUsers, FaHistory, FaFileAlt, FaChevronRight } from "react-icons/fa";

function LandingPage() {
    return (
        <div
            style={{
                background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)",
                minHeight: "100vh",
                color: "#f8fafc",
                fontFamily: "'Inter', sans-serif",
                position: "relative",
                overflow: "hidden"
            }}
        >
            {/* Decorative background glows */}
            <div
                style={{
                    position: "absolute",
                    width: "400px",
                    height: "400px",
                    background: "rgba(79, 70, 229, 0.15)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    top: "-10%",
                    right: "-10%",
                    pointerEvents: "none"
                }}
            />
            <div
                style={{
                    position: "absolute",
                    width: "450px",
                    height: "450px",
                    background: "rgba(16, 185, 129, 0.08)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    bottom: "-10%",
                    left: "-10%",
                    pointerEvents: "none"
                }}
            />

            {/* NAVBAR */}
            <nav className="navbar navbar-expand-lg navbar-dark py-3 px-4" style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.05)", background: "rgba(15, 23, 42, 0.5)", backdropFilter: "blur(12px)" }}>
                <div className="container-fluid d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2">
                        <img
                            src="/logo.png"
                            alt="Logo"
                            width="36"
                            height="36"
                            style={{ objectFit: "contain" }}
                        />
                        <span className="fw-extrabold text-white fs-4 tracking-tight" style={{ letterSpacing: "-0.5px" }}>
                            Entropy Connect
                        </span>
                    </div>

                    <Link
                        to="/login"
                        className="btn btn-primary px-4 py-2 fw-bold d-flex align-items-center gap-2 shadow-sm"
                        style={{
                            borderRadius: "10px",
                            background: "var(--primary-color)",
                            border: "none",
                            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)"
                        }}
                    >
                        Login to Portal <FaChevronRight size={10} />
                    </Link>
                </div>
            </nav>

            {/* HERO SECTION */}
            <header className="container py-5 mt-4 text-center position-relative animate-fade-in" style={{ zIndex: 10 }}>
                <div className="row justify-content-center py-5">
                    <div className="col-lg-8">
                        <span
                            className="badge px-3 py-2 text-uppercase mb-3 font-monospace"
                            style={{
                                fontSize: "12px",
                                letterSpacing: "1.5px",
                                background: "rgba(79, 70, 229, 0.15)",
                                color: "#818cf8",
                                border: "1px solid rgba(79, 70, 229, 0.3)",
                                borderRadius: "30px"
                            }}
                        >
                            <FaShieldAlt className="me-2" /> Secure Enterprise Profiling
                        </span>

                        <h1
                            className="fw-extrabold text-white mb-4 display-4 tracking-tight"
                            style={{
                                lineHeight: "1.2",
                                background: "linear-gradient(to right, #ffffff 40%, #c7d2fe 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}
                        >
                            Secure, Intelligent Agency Profiling
                        </h1>

                        <p className="fs-5 mb-5 mx-auto" style={{ maxWidth: "680px", color: "#cbd5e1", lineHeight: "1.7" }}>
                            Welcome to Entropy Connect. The ultimate portal for managing departments, tracking employee profiles, and auditing system-wide activities with military-grade security.
                        </p>

                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                            <Link
                                to="/login"
                                className="btn btn-primary px-5 py-3 fs-5 fw-bold shadow"
                                style={{
                                    borderRadius: "12px",
                                    background: "var(--primary-color)",
                                    border: "none",
                                    boxShadow: "0 6px 20px rgba(79, 70, 229, 0.4)"
                                }}
                            >
                                Enter Portal
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            {/* FEATURES SECTION */}
            <section className="container py-5 position-relative animate-fade-in" style={{ zIndex: 10, animationDelay: "0.2s" }}>
                <div className="row g-4 mt-2">
                    {/* Feature 1 */}
                    <div className="col-md-6 col-lg-3">
                        <div
                            className="card h-100 border-0 p-4"
                            style={{
                                background: "rgba(30, 41, 59, 0.4)",
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(255, 255, 255, 0.05)",
                                borderRadius: "16px"
                            }}
                        >
                            <div className="mb-3 text-primary">
                                <div className="d-inline-flex p-3 rounded-3" style={{ background: "rgba(79, 70, 229, 0.1)" }}>
                                    <FaUsers size={24} />
                                </div>
                            </div>
                            <h5 className="fw-bold text-white mb-2">Profile Management</h5>
                            <p className="small mb-0" style={{ color: "#cbd5e1", lineHeight: "1.6" }}>
                                Detailed profiles tracking personal, professional, and family details with structured tabbed layouts.
                            </p>
                        </div>
                    </div>

                    {/* Feature 2 */}
                    <div className="col-md-6 col-lg-3">
                        <div
                            className="card h-100 border-0 p-4"
                            style={{
                                background: "rgba(30, 41, 59, 0.4)",
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(255, 255, 255, 0.05)",
                                borderRadius: "16px"
                            }}
                        >
                            <div className="mb-3 text-success">
                                <div className="d-inline-flex p-3 rounded-3" style={{ background: "rgba(16, 185, 129, 0.1)" }}>
                                    <FaShieldAlt size={24} />
                                </div>
                            </div>
                            <h5 className="fw-bold text-white mb-2">Access Control</h5>
                            <p className="small mb-0" style={{ color: "#cbd5e1", lineHeight: "1.6" }}>
                                Role-based access control restricting pages and actions to authorized admins, managers, and viewers.
                            </p>
                        </div>
                    </div>

                    {/* Feature 3 */}
                    <div className="col-md-6 col-lg-3">
                        <div
                            className="card h-100 border-0 p-4"
                            style={{
                                background: "rgba(30, 41, 59, 0.4)",
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(255, 255, 255, 0.05)",
                                borderRadius: "16px"
                            }}
                        >
                            <div className="mb-3 text-warning">
                                <div className="d-inline-flex p-3 rounded-3" style={{ background: "rgba(245, 158, 11, 0.1)" }}>
                                    <FaHistory size={24} />
                                </div>
                            </div>
                            <h5 className="fw-bold text-white mb-2">Audit Logs</h5>
                            <p className="small mb-0" style={{ color: "#cbd5e1", lineHeight: "1.6" }}>
                                Full transparency with system-wide activity logs tracking all creations, updates, and logins.
                            </p>
                        </div>
                    </div>

                    {/* Feature 4 */}
                    <div className="col-md-6 col-lg-3">
                        <div
                            className="card h-100 border-0 p-4"
                            style={{
                                background: "rgba(30, 41, 59, 0.4)",
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(255, 255, 255, 0.05)",
                                borderRadius: "16px"
                            }}
                        >
                            <div className="mb-3 text-info">
                                <div className="d-inline-flex p-3 rounded-3" style={{ background: "rgba(14, 165, 233, 0.1)" }}>
                                    <FaFileAlt size={24} />
                                </div>
                            </div>
                            <h5 className="fw-bold text-white mb-2">Advanced Reports</h5>
                            <p className="small mb-0" style={{ color: "#cbd5e1", lineHeight: "1.6" }}>
                                Filter and export custom profile and activity data directly to Excel (CSV) files.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FOOTER */}
            <footer className="container py-5 mt-5 text-center position-relative animate-fade-in" style={{ zIndex: 10, animationDelay: "0.3s", borderTop: "1px solid rgba(255, 255, 255, 0.05)" }}>
                <p className="small mb-0" style={{ color: "#94a3b8" }}>
                    &copy; {new Date().getFullYear()} Entropy Connect. All rights reserved. Secure Portal Access.
                </p>
            </footer>
        </div>
    );
}

export default LandingPage;
